import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import "../analytics";

import { PATH_TO_COURSES_STATE } from "./const";
import reducer from "./reducers/state";
import * as contentsSelectors from "./selectors/state/contents";
import * as contentSelectors from "./selectors/state/contents/content";
import * as coursesSelectors from "./selectors/state/courses";
import * as courseSelectors from "./selectors/state/courses/course";
import * as modulesSelectors from "./selectors/state/modules";
import * as moduleSelectors from "./selectors/state/modules/module";
import * as sectionsSelectors from "./selectors/state/sections";
import * as sectionSelectors from "./selectors/state/sections/section";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_COURSES_STATE, builder => {
  builder.register(PATH_TO_COURSES_STATE, reducer);
});

// actions
export {
  addCourse,
  addCourseSkeleton,
  addSection,
  addWord,
  receiveCoursesDetails
} from "./actions/course";
export {
  fetchCourseActionFactory,
  fetchCourseDetailsActionFactory,
  fetchCourseSectionsActionFactory,
  fetchSectionActionFactory
} from "./actions/meta";
//drafts
export { default as ContentModuleDraft } from "./models/ContentModuleDraft";
export type { ContentModuleDraftType } from "./models/ContentModuleDraft";
export { default as CourseDraft } from "./models/CourseDraft";
export type { CourseDraftType } from "./models/CourseDraft";
export { default as Content } from "./models/state/contents/content/Content";
export type { ContentType } from "./models/state/contents/content/Content";
export { default as ContentOptions } from "./models/state/contents/content/options/ContentOptions";
export type { ContentOptionsType } from "./models/state/contents/content/options/ContentOptions";
// content
export type { Contents } from "./models/state/contents/Contents";
export { default as Course } from "./models/state/courses/course/Course";
export type {
  CourseId,
  CourseType,
  References
} from "./models/state/courses/course/Course";
// course
export type { Courses } from "./models/state/courses/Courses";
// MODELS
export { default as CoursesStateSlice } from "./models/state/CoursesStateSlice";
export { default as ContentModule } from "./models/state/modules/module/ContentModule";
export type {
  ContentModuleType,
  ModuleId
} from "./models/state/modules/module/ContentModule";
// modules
export type { Modules } from "./models/state/modules/Modules";
export { default as Section } from "./models/state/sections/section/Section";
export type {
  SectionId,
  SectionType
} from "./models/state/sections/section/Section";
// section
export type { Sections } from "./models/state/sections/Sections";
export {
  getAllCourseContentIds,
  makeGetAllCourseContentIds
} from "./selectors/getAllCourseContentIds";
export {
  getAllSectionNumbers,
  makeGetAllSectionNumbers
} from "./selectors/getAllSectionNumbers";
export {
  getDescendantLeafSectionIds,
  makeGetDescendantLeafSectionIds
} from "./selectors/getDescendantLeafSectionIds";
export {
  getLeafSectionIds,
  makeGetCourseLeafSectionIds
} from "./selectors/getLeafSectionIds";
export { makeGetCourseLeafSectionIdsAndNumbers } from "./selectors/getLeafSectionIdsAndNumbers";
export { default as makeGetSectionAnchorConceptModuleIds } from "./selectors/getSectionAnchorConceptModuleIds";
export {
  getSectionAndItsParentsNamesWithoutCourse // not memoized
} from "./selectors/getSectionAndItsParents";
export {
  makeGetSectionContentModuleIds,
  makeGetSectionContentModules,
  makeGetSectionExerciseContentModules,
  makeGetSectionModuleIdsByContentType
} from "./selectors/getSectionContentModules";
export { makeGetSectionContents } from "./selectors/getSectionContents";
export {
  getSectionNumber,
  makeGetSectionNumber
} from "./selectors/getSectionNumber";
export { makeGetSectionTitleWithNumber } from "./selectors/getSectionTitleWithNumber";
export {
  courseDetailsFetchFinished,
  courseDetailsNeedFetching,
  courseSectionsFetchFinished,
  courseSectionsNeedFetching,
  fullCourseFetchFinished,
  fullCourseNeedFetching,
  getCourseDetailsFetchError,
  // course details
  getCourseDetailsFetchStarted,
  getCourseDetailsFetchSuccess,
  getCourseDoesNotExist,
  getCourseSectionsDoNotExist,
  getCourseSectionsFetchError,
  // course sections
  getCourseSectionsFetchStarted,
  getCourseSectionsFetchSuccess,
  getFullCourseFetchError,
  getFullCourseFetchErrorMessage,
  // full course
  getFullCourseFetchStarted,
  getFullCourseFetchSuccess,
  getIsInvalidSubscriptionForSection,
  getIsInvalidSusbcriptionForCourse,
  getSectionDoesNotExist,
  getSectionFetchError,
  // section
  getSectionFetchStarted,
  getSectionFetchSuccess,
  sectionFetchFinished,
  sectionNeedsFetching
} from "./selectors/meta";
export {
  getAllSubSubSectionIds,
  getSectionCourseId,
  makeGetAllSectionContentIds,
  makeGetAllSectionContentIdsFromSections
} from "./selectors/section";
// selectors
export {
  contentIsSequential,
  contentModuleIdIsLastInContent,
  courseExists,
  courseIsPremium,
  doesCourseHaveExamQuestions,
  doesSectionHaveExamQuestions,
  // Use makeGetAllSectionContentIdsFromSections instead if possible
  getAllContentModules,
  //contents
  getAllContents,
  // courses
  getAllCourseIds,
  getAllCourses,
  getAllSectionContentIds,
  getAllSectionContentIdsFromSections,
  // sections
  getAllSections,

  //contents
  getContent,
  getContentModuleContent,
  getContentModuleDifficulty,
  getContentModuleIds,
  getContentModuleParentId,
  getContentModuleSkill,
  getContentModuleTextToSpeechDisabled,
  // modules
  getContentModuleType,
  getCourse,
  getCourseAuthors,
  getCourseDescription,
  getCourseExamQuestionsCount,
  getCourseHeaderImageURL,
  getCourseName,
  getCourseNames,
  getCourseReferences,
  getCourseRegion,
  getCourseSectionIds,
  getCoursesIdsWithVocabularyEnabled,
  getCourseStartingSectionId,
  getCourseSubscriptionTier,
  getCourseTagIds,
  getCourseTextToSpeechEnabled,
  getCourseVocabularyEnabled,
  getFirstContentModuleId,
  getFollowingContentModuleId,
  getRelatedCourseIds,
  getRelatedPremiumCourseIdsForCourses,
  getSection,
  getSectionContentIds,
  getSectionExamQuestionsCount,
  getSectionParentId,
  getSections,
  getSectionSectionIds,
  getSectionTitle,
  getTextToSpeechDisabled,
  includesContentModuleId,
  isLeafSection
} from "./selectors/state";
export {
  contentSelectors,
  contentsSelectors,
  courseSelectors,
  coursesSelectors,
  moduleSelectors,
  modulesSelectors,
  PATH_TO_COURSES_STATE,
  reducer,
  sectionSelectors,
  sectionsSelectors
};
